import { coverLetterDataSchema } from "@resume-studio/schema";
import { kebabCase } from "@resume-studio/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const importCoverLetterSchema = z.object({
  title: z.string().optional(),
  slug: z.string().min(1).transform(kebabCase).optional(),
  visibility: z.enum(["public", "private"]).default("private").optional(),
  data: coverLetterDataSchema,
});

export class ImportCoverLetterDto extends createZodDto(importCoverLetterSchema) {}
